import { Input, message } from 'ant-design-vue'
import '@/components/l8-icon'
import ImgCaptcha from './ImgCaptcha.vue'
import './index.less'

/* istanbul ignore next */
ImgCaptcha.install = function (Vue) {
  Vue.use(Input)
  Vue.component(ImgCaptcha.name, ImgCaptcha)
  Vue.prototype.$message = message
}

export default ImgCaptcha
